import { autoinject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import * as moment from 'moment';
import { PayrazrService } from '../../services/payrazr';
import { Payment } from './payment';
import { Router } from 'aurelia-router';

@autoinject
export class CancelSingleFuture{
	isSubmitting = false;
	payment: Payment;

	constructor(
		private state: State,
		private payrazrService: PayrazrService,
		private router: Router
	) {}

	activate(params, routeData) {
		this.payment = routeData.payment;
	}

	back() {
		this.router.navigateBack();
	}

	submit() {
		this.isSubmitting = true;
		this.payrazrService.cancelPaymentPlan(this.payment.plan.id).then(
			(result) => {
				this.isSubmitting = false;
				this.back();
			},
			(error) => {
				this.isSubmitting = false;
			}
		);
	}
}
